import { ApiService, Audience, Authentication } from '../../common'
import { AxiosPromise } from 'axios'
import { Orders } from '@one/types'
import qs from 'qs'

export class AppOrdersApi extends ApiService {
  getOrdersList(
    start: number,
    rows: number,
    search: string | null,
    startDate: string | null,
    endDate: string | null,
    shipmentStatuses: Array<string> | null
  ): AxiosPromise<Orders.Responses.OrderPagination> {
    return this.get('/order', {
      params: {
        start: start,
        rows: rows,
        search: search || null,
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
        shipmentStatuses: shipmentStatuses ? shipmentStatuses : null
      },
      authentication: Authentication.REQUIRED,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })
  }

  getDetailOrder(orderId: string): AxiosPromise<Orders.DetailedOrder.Order> {
    return this.get(`/order/${orderId}`, {
      authentication: Authentication.REQUIRED
    })
  }

  exportOfflineOrder(offlineOrderId: string): AxiosPromise<BlobPart> {
    return this.get('/offline-order/single/export', {
      params: { offlineOrderId },
      authentication: Authentication.REQUIRED,
      responseType: 'blob'
    })
  }
  
  getOrderStatuses(
    startDate: string | null,
    endDate: string | null,
    search: string | null
  ): AxiosPromise<Array<Orders.OrderStatusDto>> {
    return this.get('/order-status', {
      params: {
        startDate: startDate || null,
        endDate: endDate || null,
        search: search || null
      },
      authentication: Authentication.REQUIRED,
      cache: {
        tags: ['order-status']
      }
    })
  }

  getOfflineOrder(
    start: number,
    rows: number,
    search: string | null,
    startDate: string | null,
    endDate: string | null
  ): AxiosPromise<Orders.Responses.OrderPagination> {
    return this.get('/offline-order', {
      params: {
        start: start,
        rows: rows,
        search: search || null,
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null
      },
      authentication: Authentication.REQUIRED,
      cache: {
        tags: ['offline-order']
      }
    })
  }

  getSingleOfflineOrder(orderId: string): AxiosPromise<Orders.OfflineOrder> {
    return this.get(`/offline-order/single`, {
      authentication: Authentication.REQUIRED,
      params: {
        orderId
      },
      cache: {
        tags: ['offline-order']
      }
    })
  }

  payForOrder(
    orderId: string,
    callbackUrl: string
  ): AxiosPromise<Orders.Responses.PayForOrderResult> {
    return this.post(
      `/order/${orderId}/pay`,
      {
        callbackUrl
      },
      {
        authentication: Authentication.REQUIRED
      }
    )
  }

  payForOrderFromNotification(
    orderId: string,
    callbackUrl: string
  ): AxiosPromise<Orders.Responses.PayForOrderResult> {
    return this.post(
      `/order/${orderId}/pay`,
      {
        callbackUrl
      },
      {
        authentication: Authentication.OPTIONAL
      }
    )
  }

  exportOnlineOrder(orderId: string): AxiosPromise<BlobPart> {
    return this.get(`/order/${orderId}/export`, {
      authentication: Authentication.REQUIRED,
      responseType: 'blob'
    })
  }

  searchOrder(
    number: string
  ): AxiosPromise<{ type: string; order: Orders.Order | Orders.OfflineOrder }> {
    return this.get(`/order/search`, {
      params: {
        number
      },
      authentication: Authentication.REQUIRED,
      aud: Audience.APP
    })
  }
}
